/* Refillia: prima del pagamento, se manca poco alla spedizione gratuita, propone un prodotto invece della spedizione */
(function () {
  var velo = document.querySelector('[data-rfsp]');
  if (!velo) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var soglia = parseInt(velo.dataset.soglia, 10) || 6990, minimo = parseInt(velo.dataset.minimo, 10) || 5000;
  var box = velo.querySelector('.rfsp'), lista = velo.querySelector('[data-rfsp-lista]');
  var cand = [];
  try { cand = JSON.parse(velo.querySelector('[data-rfsp-cand]').textContent); } catch (e) {}
  var passa = false, prima = null;

  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function scegli(manca, nelCarrello) {
    // per ogni prodotto il formato più economico che basta; poi i due più vicini alla cifra che manca
    var ok = [];
    cand.forEach(function (c) {
      if (nelCarrello[c.p]) return;
      var migliore = null;
      c.v.forEach(function (v) { if (v[1] >= manca && (!migliore || v[1] < migliore[1])) migliore = v; });
      if (migliore) ok.push({ c: c, v: migliore });
    });
    ok.sort(function (a, b) { return a.v[1] - b.v[1]; });
    return ok.slice(0, 2);
  }
  function riga(x) {
    var sotto = x.c.isp ? 'ispirato a ' + x.c.isp : x.c.c;
    var formato = x.v[2] && x.v[2] !== 'Default Title' ? ' · ' + x.v[2] : '';
    return '<div class="rfsp-p"><span class="rfsp-p__foto">' + (x.c.i ? '<img src="' + esc(x.c.i) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
      '<span class="rfsp-p__t"><b>' + esc(x.c.n) + '</b><span>' + esc(sotto + formato) + '</span><strong>' + eur(x.v[1]) + '</strong></span>' +
      '<button type="button" data-rfsp-metti="' + x.v[0] + '">Aggiungi al carrello</button></div>';
  }
  function apri(cart) {
    var manca = soglia - cart.total_price;
    var dentro = {};
    (cart.items || []).forEach(function (it) { dentro[it.product_id] = true; });
    var scelti = scegli(manca, dentro);
    if (!scelti.length) return false;
    velo.querySelector('[data-rfsp-manca]').textContent = eur(manca);
    lista.innerHTML = scelti.map(riga).join('');
    box.classList.remove('ok');
    prima = document.activeElement;
    velo.hidden = false;
    document.documentElement.classList.add('rfsp-bloccato');
    velo.querySelector('[data-rfsp-chiudi]').focus({ preventScroll: true });
    return true;
  }
  function chiudi() {
    velo.hidden = true;
    document.documentElement.classList.remove('rfsp-bloccato');
    if (prima && prima.focus) prima.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-rfk-paga], a[href$="/checkout"]:not([data-rfsp-avanti]):not([data-rfsp-salta])');
    if (!a || passa || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    var dove = a.href;
    fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.total_price >= minimo && cart.total_price < soglia && apri(cart)) return;
      passa = true; window.location.href = dove;
    }).catch(function () { passa = true; window.location.href = dove; });
  }, true);

  lista.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rfsp-metti]');
    if (!b || b.disabled) return;
    b.disabled = true; b.textContent = 'Un attimo…';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.rfspMetti, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        lista.querySelectorAll('.rfsp-p').forEach(function (p) { p.classList.remove('messo'); });
        lista.querySelectorAll('[data-rfsp-metti]').forEach(function (x) { if (x !== b) x.disabled = true; });
        b.closest('.rfsp-p').classList.add('messo'); b.textContent = 'Aggiunto al carrello';
        box.classList.add('ok');
        // dopo l'aggiunta si va dritti al pagamento, con un attimo per leggere la conferma
        passa = true;
        var vai = velo.querySelector('[data-rfsp-avanti]');
        vai.textContent = 'Ti portiamo al pagamento…';
        setTimeout(function () { window.location.href = vai.href; }, 900);
      })
      .catch(function () { b.disabled = false; b.textContent = 'Riprova'; });
  });
  velo.addEventListener('click', function (e) {
    if (e.target === velo || e.target.closest('[data-rfsp-chiudi]')) chiudi();
    if (e.target.closest('[data-rfsp-avanti], [data-rfsp-salta]')) passa = true;
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !velo.hidden) chiudi(); });
})();
